import { useMemo } from "react";
import { InputAdornment, Stack, TextField, styled } from "@mui/material";
import clsx from "clsx";
import SmallText from "components/Typography/SmallText";
import { Loader } from "components";

const TextFieldUnstyled = ({
  className,
  classNames = {}, // root, label, input, htmlInput
  corners = "round", // 'square' | 'round'
  id,
  defaultValue,
  label,
  helperText,
  isReadOnly = false,
  isLoading,
  isDisabled = false,
  isError = false,
  isMultiline = false,
  isFullWidth = true,
  isViewMode,
  name,
  onChange,
  onClick,
  placeholder,
  minRows = 3,
  maxRows,
  value,
  slotProps = {}, // inputLabel, input:{startAdornment,endAdornment}, hmtlInput
  inputRef,
  ...props
}) => {
  const inputId = useMemo(
    () => (id || name) + (Math.random() * 1000).toString(),
    [id, name]
  );

  const shouldShowLoader = !isViewMode && isLoading;
  const shouldDisable = isViewMode || isDisabled || isLoading;

  return (
    <TextField
      {...props}
      inputRef={inputRef}
      id={inputId}
      disabled={shouldDisable}
      error={Boolean(isError)}
      fullWidth={isFullWidth}
      multiline={isMultiline}
      maxRows={maxRows}
      minRows={minRows}
      placeholder={isViewMode ? "" : placeholder}
      name={name}
      onChange={onChange}
      onClick={onClick}
      value={value}
      label={label}
      defaultValue={defaultValue}
      helperText={helperText}
      className={clsx(
        "root",
        { "view-mode": isViewMode },
        className,
        classNames.root
      )}
      slotProps={{
        inputLabel: {
          shrink: false,
          className: clsx("label", classNames.label),
          ...slotProps.inputLabel,
        },
        input: {
          readOnly: isReadOnly,
          className: clsx(
            "input",
            corners,
            { "view-mode": isViewMode },
            classNames.input
          ),
          ...slotProps.input,
          ...(slotProps.input?.startAdornment
            ? {
                startAdornment: (
                  <InputAdornment position="start">
                    {typeof slotProps.input?.startAdornment === "string" ? (
                      <SmallText>{slotProps.input.startAdornment}</SmallText>
                    ) : (
                      slotProps.input.startAdornment
                    )}
                  </InputAdornment>
                ),
              }
            : {}),
          ...(slotProps.input?.endAdornment || shouldShowLoader
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <Stack direction="row" alignItems="center" gap={1}>
                      {typeof slotProps.input?.endAdornment === "string" ? (
                        <SmallText>{slotProps.input.endAdornment}</SmallText>
                      ) : (
                        slotProps.input.endAdornment
                      )}
                      {shouldShowLoader && (
                        <Loader color="text.secondary" size={20} />
                      )}
                    </Stack>
                  </InputAdornment>
                ),
              }
            : {}),
        },
        htmlInput: {
          className: clsx("html-input", classNames.htmlInput),
          ...slotProps.htmlInput,
        },
      }}
    />
  );
};

const TextFieldCustom = styled(TextFieldUnstyled)({});

export default TextFieldCustom;
